export const SET_ADAS_IDS = 'SET_ADAS_IDS'
export const SET_ADASINSPECTION = 'SET_ADASINSPECTION'
export const SET_ADAS_MATRICES = 'SET_ADAS_MATRICES'
export const SET_LINKS = 'SET_LINKS'
export const SET_LOOKUPS = 'SET_LOOKUPS'
export const SET_REPAIRLINES = 'SET_REPAIRLINES'

export const SESSION_ADAS_MATRIX = 'SESSION_ADAS_MATRIX'



// WEBPACK FOOTER //
// ./src/store/modules/adas/types.js